<template lang="html">
  <section class="sub-main take-place column advisor">
		<!-- <patrimonial-short /> -->
		<force-complete-profile-banner v-if="isForceCompleteProfile"/>
		<no-estate-short v-else-if="!isEstate"/>

		<div class="ctn-advisors-part column">
			<div class="ctn-advisors-tile row">
				<div class="advisor-tile" v-for="(advisor, key) in advisors" v-bind:key="key">
					<div class="title">
						{{ (key === 0) ? 'Mon patrimofficer principal' : 'Mon patrimofficer adjoint'}}
					</div>
					<div class="advisor-part row">
						<div class="profile row">
							<div class="ctn-profile-picture">
								<img :src="resolvePicture(advisor)">
							</div>
							<div class="names">
								<div class="name">
									{{ advisor.first_name }} {{ advisor.last_name }}
								</div>
								<div class="function">
									{{ advisor.title || '-' }}
								</div>
								<div class="phone">
									{{ advisor.phone || '-' }}
								</div>
							</div>
						</div>
						<div class="plan-rdv column" :class="{noAvailable: !advisor.available}" v-if="advisor.available">
							<div class="btn btn-red" :class="{'btn-red': advisor.available, 'btn-grey': !advisor.available}" @click="displayTakeAppointment=true">
								Planifier un RDV
							</div>
							<!-- <div class="planned-rdv" v-if="advisor.available">
								<div class="label">
									RDV planifié
								</div>
								<div class="date">
									12/04/2018 à 10:00
								</div>
							</div> -->
						</div>
						<div class="ooo-message" v-if="!advisor.available">
							{{ advisor.ooo_message || '' }}
						</div>
					</div>
				</div>
			</div>
			<chat :threads="threads" :isAdvisor="false" />
		</div>
		<base-modal :content="modalTakeAppointment" :show="displayTakeAppointment" :data="null" @close="displayTakeAppointment=false"/>
		<div v-if="isAnonymous" class="restricted-access column">
			<div class="title">
				Complétez votre inscription pour bénéficier<br/>
				de toutes les fonctionnalités Patrimoffice
			</div>
			<div class="subtitle">
				Ainsi que d'un essai gratuit d'un mois
			</div>
			<router-link class="btn btn-red" :to="{ name: 'AnonymousUpgrade' }">
				Compléter mon inscription <i class="icon-arrow-full-right"></i>
			</router-link>
		</div>
  </section>
</template>

<script>
import Chat from '@/common/components/chat'
import TakeAppointment from '@/components/modal/takeAppointment'
import PatrimonialShort from '@/components/PatrimonialShort'
import NoEstateShort from '@/components/NoEstateShort'
import { exchanges, advisors } from '@/fixtures/advisors'
import { mapGetters } from 'vuex'
import ForceCompleteProfileBanner from '@/components/ForceCompleteProfileBanner'

export default {
	name: 'Advisor',
	components: {
		PatrimonialShort,
		Chat,
		NoEstateShort,
		ForceCompleteProfileBanner
	},
	data () {
		return {
			currentExchangeId: 0,
			modalTakeAppointment: TakeAppointment,
			displayTakeAppointment: false,
			displayReplyMessage: false,
			defaultAdvisors: advisors,
			defaultExchanges: exchanges
		}
	},
	mounted () {
		this.$store.dispatch('getMessages', this.user.id)
	},
	methods: {
		setCurrentMessage (id) {
			this.currentExchangeId = id
		},
		resolvePicture (a) {
			return (a.media) ? process.env.ASSETS_ROOT + a.media.file : process.env.API_ROOT + '/assets/user.png'
		}
	},
	computed: {
		...mapGetters({
			user: 'user',
			isAnonymous: 'isAnonymous',
			threads: 'threads',
			isEstate: 'isEstate',
			isForceCompleteProfile: 'isForceCompleteProfile'
		}),
		currentExchange () {
			return this.exchanges[this.currentExchangeId]
		},
		advisors () {
			return (this.isAnonymous) ? this.defaultAdvisors : this.user.advisors
		},
		threadsReverse () {
			return this.$iRobot.arrayClone(this.threads).reverse()
		}
	}
}
</script>

<style lang="scss" scoped>
.ctn-profile-picture {
	position: relative;

	img {
		position: absolute;
    width: 90px;
    height: 90px;
	}
}

.sub-main {
	position: relative;
}

.ctn-advisors-part {
	max-width: 1080px;
	width: 100%;
	margin: 0 1rem;
}
</style>



// WEBPACK FOOTER //
// src/views/Advisor.vue